import React from 'react';
import styled from 'styled-components/macro';
import PropTypes from 'prop-types';
import { Steps } from 'antd';

const OPACITY_6 = 0.6;
const ICON_WIDTH_HEIGHT = '24px';

const Step = styled(Steps.Step)`
  height: 60px;
  color: ${props => props.theme.color.white} !important;

  @media (min-width: 768px) {
    height: 80px;
  }
`;

const ActiveIcon = styled.div`
  border-radius: 50%;
  border-color: ${props => props.theme.color.white};
  border-style: solid;
  border-width: 4px;
  width: ${ICON_WIDTH_HEIGHT};
  height: ${ICON_WIDTH_HEIGHT};
`;

const DeactiveIcon = styled.div`
  border-radius: 50%;
  background-color: ${props => props.theme.color.white};
  width: ${ICON_WIDTH_HEIGHT};
  height: ${ICON_WIDTH_HEIGHT};
  opacity: ${OPACITY_6};
`;

const StepTitle = ({ label, isActive }) => <Label isActive={isActive}>{label}</Label>;
const Label = styled.span`
  color: ${props => props.theme.color.white};
  opacity: ${props => (props.isActive ? 1 : OPACITY_6)};
  font-size: 16px;
`;

const getSteps = (currentPath, steps) => {
  return steps.map(step => (step.path === currentPath ? { ...step, isActive: true, icon: <ActiveIcon /> } : step));
};

const ProgressIndicator = props => {
  const { currentPath, steps } = props;
  return (
    <Steps direction="vertical" size="small">
      {getSteps(currentPath, steps).map(step => (
        <Step
          title={<StepTitle label={step.label} isActive={step.isActive} />}
          icon={step.isActive ? <ActiveIcon /> : <DeactiveIcon />}
          key={step.path}
        />
      ))}
    </Steps>
  );
};

export default ProgressIndicator;

ProgressIndicator.propTypes = {
  currentPath: PropTypes.string,
  steps: PropTypes.array
};
